import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-legend-dialog',
  templateUrl: './legend-dialog.component.html',
  styleUrls: ['./legend-dialog.component.scss']
})
export class LegendDialogComponent implements OnInit {

  public title = 'SCORECARD LEGEND';
  constructor(
    private dialogRef: MatDialogRef<LegendDialogComponent>,
  ) { }

  ngOnInit() {
  }

}
